import React from 'react';
import { connect } from "react-redux";
import {
    DetailsList,
    Spinner,
    SpinnerSize,
    DatePicker,
    MessageBar,
    MessageBarType,
    CheckboxVisibility,
    Dropdown
} from 'office-ui-fabric-react';
import axios from 'axios';
import config from '../config';
import _ from 'lodash';
import moment from 'moment';

export class StaffReporing extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: true,
            error: false,
            data: [],
            users: [],
            startDate: null,
            endDate: null,
            activity: 'all',
            staff: 'all'
        }
    }
    componentDidMount() {
        this.loadData();
        axios.get(config.apiUrl + '/user/all')
        .then(({data}) => this.setState({
            users: data
        }))
        .catch((ex) => {
            console.error(ex)
            this.setState({
                isLoading: false,
                error: true
            });
        });
    }


    loadData() {
        this.setState({
            isLoading: true
        });
        axios.get(config.apiUrl + '/auth/activities', {
            params: {
                start: this.state.startDate,
                end: this.state.endDate,
                activity: this.state.activity,
                staff: this.state.staff
            }
        })
            .then(({ data }) => {
                this.setState({
                    data: data,
                    isLoading: false,
                    error: false
                });
            })
            .catch((ex) => {
                this.setState({
                    isLoading: false,
                    error: true
                });
            });
    }

    changeFilter(key, value) {
        this.setState({
            [key]: value
        });
        setTimeout(() => {
            this.loadData();
        }, 200);
    }

    changeDate(key, date) {
        this.setState({
            [key]: date
        });

        setTimeout(() => {
            this.loadData();
        }, 500);
    }


    widthChart() {
        try {
            var data = this.state.data;
            var v = data.length / 10;
            v = v > 1 ? v : 1;
            return Math.round(window.innerWidth * v);
        }
        catch (ex) {
            return 1000;
        }
    }

    heightChart() {
        try {
            return window.innerHeight - 100;
        }
        catch (ex) {
            return 600;
        }
    }

    render() {
        const { data, isLoading, error, startDate, endDate, activity, users, staff } = this.state;
        const { isDisplayChart, isDisplayTable } = this.props;
        if (error) {
            return <div>
                <MessageBar messageBarType={MessageBarType.error}>
                    Load error
        </MessageBar>
            </div>
        }
        return (
            <div>
                <div className="ms-Grid" style={{ marginTop: 10 }}>
                    <div className="ms-Grid-col ms-u-md3">
                        <Dropdown
                            selectedKey={staff}
                            options={[{ key: 'all', text: 'Staff: All'}].concat(users.map(e => ({key: e._id, text: e.email})))}
                            onChanged={v => this.changeFilter('staff', v.key)}/>
                    </div>
                    <div className="ms-Grid-col ms-u-md2">
                        <Dropdown
                            selectedKey={activity}
                            options={[
                                { key: 'all', text: 'Activity: All'},
                                {key: 'token', text: 'Refresh Web'},
                                { key: 'login', text: 'Login'},
                                {key: 'logout', text: 'Logout'},
                                {key: 'break-out', text: 'Break Out'},
                                {key: 'break-in', text: 'Break In'},
                                {key: 'load-customer', text: 'Load Customer'},
                                {key: 'update-customer', text: 'Update Customer'},
                                {key: 'hang-up', text: 'Hang up'},
                                {key: 'calling', text: 'Calling'}
                            ]}
                            onChanged={v => this.changeFilter('activity', v.key)}/>
                    </div>
                    <div className="ms-Grid-col ms-u-md1"></div>
                    <div className="ms-Grid-col ms-u-md3">
                        <DatePicker label='Start Date'
                            className="one-line-100"
                            formatDate={date => moment(date).format('MMM DD YYYY')}
                            value={startDate ? new Date(startDate) : null}
                            onSelectDate={date => this.changeDate('startDate', date)}
                            allowTextInput />
                    </div>
                    <div className="ms-Grid-col ms-u-md3">
                        <DatePicker label='End Date'
                            className="one-line-100"
                            formatDate={date => moment(date).format('MMM DD YYYY')}
                            value={endDate ? new Date(endDate) : null}
                            onSelectDate={date => this.changeDate('endDate', date)}
                            allowTextInput />
                    </div>
                </div>
                {isLoading ?
                    <Spinner size={SpinnerSize.large} /> :
                    <div>
                        <DetailsList
                            items={data}
                            columns={columns}
                            checkboxVisibility={CheckboxVisibility.hidden}
                            style={{ fontSize: 14 }}
                        />
                    </div>
                }
            </div>
        )
    }

}

export default connect(state => ({
    auth: state.auth
}))(StaffReporing);

const columns = [
    {
        key: 'date',
        name: 'Date',
        fieldName: 'date',
        minWidth: 80,
        maxWidth: 80,
        onRender(item) {
            return moment(new Date(item.createdAt)).format('MM/DD/YYYY')
        }
    },
    {
        key: 'time',
        name: 'Time',
        fieldName: 'time',
        minWidth: 60,
        maxWidth: 60,
        onRender(item) {
            return moment(new Date(item.createdAt)).format('HH:mm')
        }
    },
    {
        key: 'type',
        name: 'Action',
        fieldName: 'type',
        minWidth: 120,
        maxWidth: 120,
    },
    {
        key: 'staff',
        name: 'Staff',
        fieldName: 'staff',
        minWidth: 300,
        maxWidth: 300,
        onRender(item) {
            return item.user.fname + ' ' + item.user.lname;
        }
    },
    {
        key: 'email',
        name: 'Email',
        fieldName: 'email',
        minWidth: 300,
        maxWidth: 300,
        onRender(item) {
            return item.user.email
        }
    },
    {
        key: 'role',
        name: 'Role',
        fieldName: 'role',
        minWidth: 60,
        maxWidth: 60,
        onRender(item) {
            return item.user.accountType
        }
    },
    {
        key: 'status',
        name: 'Status',
        fieldName: 'status',
        minWidth: 60,
        maxWidth: 60,
        onRender(item) {
            return item.user.deleted ? 'DELETED' : 'ACTIVE'
        }
    }
]


// WEBPACK FOOTER //
// ./client/components/Activities.js